<style lang="stylus">
    .guide-modal
        width 600px

        .guide-cons
            display flex

            .guide-names
                width 100px
                height 360px
                border-right 1px solid #e0e0e0
                text-align center

                >div
                    height 30px
                    width 80px
                    margin 0 auto
                    border-radius 5px
                    line-height 30px
                    margin-top 15px
                    cursor pointer

                .active-name
                    cursor default
                    color #017eff
                    background-color #eeeeee

            .guide-contents
                width 500px
                height 360px
                padding 15px 20px

                >div
                    font-size 14px
                    margin-bottom 5px
</style>

<template>
    <Dialog class="guide-modal" :mask="true" :media="false" :title="$t('title')">
        <div class="guide-cons">
            <div class="guide-names">
                <div v-for="(item, index) in guides" @click="changeGuideIndex(index)" :class="{ 'active-name': index === activeIndex }">
                    {{ $t(item.name) }}
                </div>
            </div>
            <div class="guide-contents">
                <div v-text="activeDes"></div>
                <video :src="activeSrc" autoplay muted playsinline loop />
            </div>
        </div>
    </Dialog>
</template>

<script lang="ts">
    import Dialog from "./Dialog.vue";
    import { Component, Prop, Vue } from "vue-property-decorator";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
        },
    })
    export default class Prepare extends Vue {
        // 初始数据可以直接声明为实例的属性
        get activeIndex() {
            return this.$store.state.ui.guideActiveIndex;
        }
        set activeIndex(v) {
            this.$store.commit("setStatus", {
                type: "guideActiveIndex",
                data: v,
            });
        }
        guides = [
            {
                name: "lineStyle",
                src: "./source/guide/0-lineStyle.mp4",
            },
            {
                name: "selAll",
                src: "./source/guide/0-selectShape.mp4",
            },
            {
                name: "defaultSet",
                src: "./source/guide/0-userSetting.mp4",
            },
            {
                name: "floatBtn",
                src: "./source/guide/0-floatBtn.mp4",
            },
            // {
            //     name: "collectSymbol",
            //     name: "./source/guide/addShape.mp4"
            // },
            {
                name: "publishTemp",
                src: "./source/guide/0-publish.mp4",
            },
        ];

        get activeSrc() {
            return this.guides[this.activeIndex].src;
        }

        get activeDes() {
            return this.$t(this.guides[this.activeIndex].name + "Des");
        }
        changeGuideIndex(index) {
            this.activeIndex = index;
            this.$track("Operation guide", "clickwindowbutton", ["lineStyle", "selAll", "defaultSet", "floatBtn", "publishTemp"][index]);
        }

        //生命周期
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "功能向导",
    "lineStyle": "线条样式",
    "lineStyleDes": "单个面板即可快速改变连接线样式",
    "selAll": "选择所有",
    "selAllDes": "右键菜单分类选择所有即可快速定位您想选择的所有同类型图形",
    "defaultSet": "默认设置",
    "defaultSetDes": "默认设置帮助您定义您所喜欢的各种设置",
    "floatBtn": "浮动按钮",
    "floatBtnDes": "您可以自定义浮动按钮的功能显示",
    "collectSymbol": "收藏符号",
    "publishTemp": "发布模板",
    "publishTempDes": "发布模板即可赚取属于您的收益！"
  },
  "en": {
    "title": "Operate Guide",
    "lineStyle": "Line Style",
    "lineStyleDes": "Single panel can quickly change the relationship line style",
    "selAll": "Select All",
    "selAllDes": "Right-click menu to select all to quickly locate all the shapes you want",
    "defaultSet": "Default Settings",
    "defaultSetDes": "Default settings help to define your individual settings",
    "floatBtn": "Float Button",
    "floatBtnDes": "Customize the function of float button",
    "collectSymbol": "Collect Symbol",
    "publishTemp": "Publish Template",
    "publishTempDes": "Publish the templates to make profit!"
  },
  "es": {
    "title": "Guía de operación",
    "lineStyle": "Estilo de línea",
    "lineStyleDes": "Un solo panel puede cambiar rápidamente el estilo de la línea de conexión",
    "selAll": "Seleccionar todo",
    "selAllDes": "Haz clic en el botón derecho en la categoría del menú para seleccionar todo y ubicar rápidamente todos los gráficos del mismo tipo que desea seleccionar",
    "defaultSet": "Configuración predeterminada",
    "defaultSetDes": "La configuración predeterminada te ayuda a definir las distintas configuraciones que te gustan",
    "floatBtn": "Botón flotante",
    "floatBtnDes": "Puedes personalizar la visualización de la función del botón flotante",
    "collectSymbol": "Coleccionar símbolo",
    "publishTemp": "Publicar plantilla",
    "publishTempDes": "¡Publica la plantilla para obtener tus ingresos!"
  },
  "jp": {
    "title": "操作ガイド",
    "lineStyle": "線のスタイル",
    "lineStyleDes": "1つのパネルで接続線のスタイルをすばやく変更できます",
    "selAll": "すべて選択",
    "selAllDes": "メニューを右クリックすると、同じ種類の図形を見つけることができます",
    "defaultSet": "初期設定",
    "defaultSetDes": "初期設定はお好きな様々な設定を簡単に実現します",
    "floatBtn": "フローティングボタン",
    "floatBtnDes": "フローティングボタンをカスタマイズできます",
    "collectSymbol": "お気に入りの記号",
    "publishTemp": "テンプレートを公開",
    "publishTempDes": "テンプレートを公開して、利益を獲得しましょう！"
  },
  "fr": {
    "title": "Assistant de fonction",
    "lineStyle": "Style de ligne",
    "lineStyleDes": "Un seul panneau peut changer rapidement le style de ligne de connexion",
    "selAll": "Tout sélectionner",
    "selAllDes": "Catégorie de menu avec le bouton droit de la souris pour tout sélectionner afin de localiser rapidement tous les graphiques de même type que vous souhaitez sélectionner",
    "defaultSet": "Paramètres par défaut",
    "defaultSetDes": "Les paramètres par défaut vous aident à définir les différents paramètres que vous aimez",
    "floatBtn": "Bouton flottant",
    "floatBtnDes": "Vous pouvez personnaliser l'affichage des fonctions du bouton flottant",
    "collectSymbol": "Symbole de la collection",
    "publishTemp": "Publier le modèle",
    "publishTempDes": "Publiez le modèle pour gagner votre revenu!"
  },
  "pt": {
    "title": "Guia de Operação",
    "lineStyle": "Estilo de Linha",
    "lineStyleDes": "Um único painel pode mudar rapidamente o estilo da linha de conexão",
    "selAll": "Selecionar tudo",
    "selAllDes": "Clique com o botão direito na categoria do menu para selecionar todos os gráficos e, em seguida, encontre rapidamente todos os gráficos do mesmo tipo a serem selecionados",
    "defaultSet": "Configuração Padrão",
    "defaultSetDes": "As configurações padrão ajudam a definir as várias configurações que você gosta",
    "floatBtn": "Botão Flutuante",
    "floatBtnDes": "Você pode personalizar a exibição de funções do botão flutuante",
    "collectSymbol": "Coletar Símbolo",
    "publishTemp": "Publicar Modelo",
    "publishTempDes": "Publique o modelo para ganhar sua renda!"
  },
  "de": {
    "title": "Funktionsassistent",
    "lineStyle": "Linienstil",
    "lineStyleDes": "单个面板即可快速改变连接线样式",
    "selAll": "Alle auswählen",
    "selAllDes": "右键菜单分类选择所有即可快速定位您想选择的所有同类型图形",
    "defaultSet": "默认设置",
    "defaultSetDes": "默认设置帮助您定义您所喜欢的各种设置",
    "floatBtn": "浮动按钮",
    "floatBtnDes": "您可以自定义浮动按钮的功能显示",
    "collectSymbol": "收藏符号",
    "publishTemp": "发布模板",
    "publishTempDes": "发布模板即可赚取属于您的收益！"
  },
  "it": {
    "title": "Guida operativa",
    "lineStyle": "Stile della linea",
    "lineStyleDes": "Un singolo pannello può cambiare rapidamente lo stile della linea di connessione",
    "selAll": "Seleziona tutto",
    "selAllDes": "Fare clic con il tasto destro sulla categoria del menu per selezionare tutto e individuare rapidamente tutti gli elementi grafici dello stesso tipo che si desidera selezionare",
    "defaultSet": "Impostazioni predefinite",
    "defaultSetDes": "Le impostazioni predefinite ti aiutano a definire le varie impostazioni che ti piacciono",
    "floatBtn": "Pulsante fluttuante",
    "floatBtnDes": "È possibile personalizzare la visualizzazione della funzione del pulsante mobile",
    "collectSymbol": "Raccogli il simbolo",
    "publishTemp": "Pubblica il modello",
    "publishTempDes": "Pubblica il modello per ottenere il tuo reddito!"
  },
  "tw": {
    "title": "功能嚮導",
    "lineStyle": "線條樣式",
    "lineStyleDes": "單個面板即可快速改變連接線樣式",
    "selAll": "選擇所有",
    "selAllDes": "右鍵菜單分類選擇所有即可快速定位您想選擇的所有同類型圖形",
    "defaultSet": "默認設置",
    "defaultSetDes": "默認設置幫助您定義您所喜歡的各種設置",
    "floatBtn": "浮動按鈕",
    "floatBtnDes": "您可以自定義浮動按鈕的功能顯示",
    "collectSymbol": "收藏符號",
    "publishTemp": "發佈模板",
    "publishTempDes": "發佈模板即可賺取屬於您的收益！"
  },
  "kr": {
    "title": "기능 가이드",
    "lineStyle": "라인 스타일",
    "lineStyleDes": "패널 하나로 연결선 스타일을 빠르게 바꿀 수 있습니다",
    "selAll": "모두 선택",
    "selAllDes": "원하는 도형을 모두 빠르게 찾으려면 메뉴를 마우스 오른쪽 단추로 클릭하여 모두 선택",
    "defaultSet": "기본 설정",
    "defaultSetDes": "기본 설정은 원하는 설정을 정의할 수 있도록 도와줍니다",
    "floatBtn": "이동 버튼",
    "floatBtnDes": "이동 버튼의 기능 사용자 지정",
    "collectSymbol": "기호 수집",
    "publishTemp": "템플릿 게시",
    "publishTempDes": "수익을 내려면 템플릿을 게시하십시오!"
  }
}
</i18n>
